import * as Events from '@emav-util/events.js';
import window from 'global/window';
var EventTarget = function EventTarget() {
};
EventTarget.prototype.allowedEvents_ = {};
EventTarget.prototype.on = function (type, fn) {
    var ael = this.addEventListener;
    this.addEventListener = function () {
    };
    Events.on(this, type, fn);
    this.addEventListener = ael;
};
EventTarget.prototype.addEventListener = EventTarget.prototype.on;
EventTarget.prototype.off = function (type, fn) {
    Events.off(this, type, fn);
};
EventTarget.prototype.removeEventListener = EventTarget.prototype.off;
EventTarget.prototype.one = function (type, fn) {
    var ael = this.addEventListener;
    this.addEventListener = function () {
    };
    Events.one(this, type, fn);
    this.addEventListener = ael;
};
EventTarget.prototype.trigger = function (event) {
    console.log('#########11111111111111#############');
    var type = event.type || event;
    if (typeof event === 'string') {
        event = { type: type };
    }
    event = Events.fixEvent(event);
    if (this.allowedEvents_[type] && this['on' + type]) {
        this['on' + type](event);
    }
    Events.trigger(this, event);
};
EventTarget.prototype.dispatchEvent = EventTarget.prototype.trigger;
var EVENT_MAP;
EventTarget.prototype.queueTrigger = function (event) {
    var _this = this;
    if (!EVENT_MAP) {
        EVENT_MAP = new Map();
    }
    var type = event.type || event;
    var map = EVENT_MAP.get(this);
    if (!map) {
        map = new Map();
        EVENT_MAP.set(this, map);
    }
    var oldTimeout = map.get(type);
    map['delete'](type);
    window.clearTimeout(oldTimeout);
    var timeout = window.setTimeout(function () {
        if (map.size === 0) {
            map = null;
            EVENT_MAP['delete'](_this);
        }
        _this.trigger(event);
    }, 0);
    map.set(type, timeout);
};
export default EventTarget;